/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {JobTaskFileNameChooserProps} from './JobTaskFileNameChooser';
import JobTaskLMUConfigChooser from './JobTaskLMUConfigChooser';
import {
  isLMUConfigTask
} from './JobTaskSearchUtils';

/**
 * Defines the `JobTaskSearchChooser` prop type definitions. This component
 * requires a `task` prop from which the associated Custom Search Component
 * will be rendered based on specific attributes of the task, generally, a
 * combination of the `deviceType` and `fileType` values.
 *
 * @see isLMUConfigTask
 */
export type JobTaskSearchChooserProps = JobTaskFileNameChooserProps

/**
 * The `JobTaskSearchChooser` provides a factory component which manages
 * rendering the Custom Search based File Chooser implementation for the
 * provided `task`.
 *
 * @see {@link JobTaskLMUConfigChooser}
 * @see {@link isLMUConfigTask}
 *
 * @param task the task which is to have an custom search implementation
 *        applied.
 */
const JobTaskSearchChooser = (props: JobTaskSearchChooserProps) => {
  if (isLMUConfigTask(props.row.task)) {
    return <JobTaskLMUConfigChooser {...props} />;
  }
};

export default JobTaskSearchChooser;
